import CSVPreviewSection from '../CSVPreviewSection'

export default function TTDetailCSVPreviewGroupingSection(){}

TTDetailCSVPreviewGroupingSection.prototype = new CSVPreviewSection();

TTDetailCSVPreviewGroupingSection.prototype.constructor = TTDetailCSVPreviewGroupingSection;

TTDetailCSVPreviewGroupingSection.prototype.init = function( numberOfSelectedLevels, columnStrategy ){
    CSVPreviewSection.prototype.init.call(this);

    this.numberOfLevels = numberOfSelectedLevels;
    this.numberOfDataRows = 4 - numberOfSelectedLevels;
    this.columnStrategy = columnStrategy;
    return this;
};

TTDetailCSVPreviewGroupingSection.prototype.addRows = function( tBody ){
    for (let i = 0; i < this.numberOfLevels; i++ ){
        const row = this.createRow()
        this.columnStrategy.addDataLevelRowCells(row, i);
        this.addRow(tBody, row);
    }

    for (let i = 0; i < this.numberOfDataRows; i++) {
        const row = this.createRow()
        this.columnStrategy.addDataRowCells(row);
        this.addRow(tBody, row);
    }
};



// WEBPACK FOOTER //
// ./web/js/reports/preview/csv/ttdetail/TTDetailCSVPreviewGroupingSection.js